import {Route} from '@angular/router';
import {EmProductGroupsPageComponent} from './product-groups/product-groups-page/product-groups-page.component';
import {EmProductsListPageComponent} from './products-list-page/products-list-page/products-list-page.component';
import {productsCountGuard} from '@em/data-feed/data-access-products';

export const dataFeedFeatureProductsRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full',
  },
  {path: 'list', component: EmProductsListPageComponent},

  {
    path: 'groups',
    component: EmProductGroupsPageComponent,
    canActivate: [productsCountGuard],
  },
];
